export default __webpack_public_path__ + "static/media/flag-new-caledonia.3883bcab.svg";